export const GET_INVOICE_INIT_ACTION =
  "GET_INVOICE_INIT_ACTION";
export const GET_INVOICE_SUCCESS_ACTION =
GET_INVOICE_INIT_ACTION + "_SUCCESS";
export const GET_INVOICE_FAIL_ACTION =
GET_INVOICE_INIT_ACTION + "_ERROR";

export function getInvoices(value) {
  return {
    type: GET_INVOICE_INIT_ACTION,
    value:value,
  };
}

export function invoicepageSelected(value) {
    return {
        type:GET_INVOICE_INIT_ACTION,
        value:value,
    }
}
